<template>
  <modal :name="name" :width="560" height="auto" :adaptive="true" :click-to-close="false">
    <section v-if="leave" class="leave-mutation">
      <app-modal-header design="new" :title="kind === 'change' ? 'Change leave dates' : 'Cancel leave'" @close="close" />
      <form class="leave-mutation__form" @submit.prevent="submit">
        <div class="leave-mutation__period">
          <div class="leave-mutation__date">
            <span>From</span>
            <strong>{{ formatDate(leave.from_date) }}</strong>
          </div>
          <i class="pi pi-arrow-right leave-mutation__arrow" aria-hidden="true" />
          <div class="leave-mutation__date">
            <span>To</span>
            <strong>{{ formatDate(leave.to_date) }}</strong>
          </div>
          <span class="leave-mutation__days">{{ leaveDays }} {{ leaveDays === 1 ? 'day' : 'days' }}</span>
        </div>
        <template v-if="kind === 'change'">
          <app-form-group design="new" label="New start" required><app-date-picker v-model="form.from_date" design="new" /></app-form-group>
          <app-form-group design="new" label="New end" required><app-date-picker v-model="form.to_date" design="new" /></app-form-group>
        </template>
        <app-form-group design="new" label="Reason" required><app-textarea v-model="form.reason" design="new" /></app-form-group>
        <p v-if="error" role="alert">{{ error }}</p>
        <footer class="leave-mutation__footer">
          <p v-if="!approve" class="leave-mutation__notice">The leave stays active until approval.</p>
          <app-button design="new" type="submit" :disabled="saving">{{ approve ? 'Create & approve' : 'Send request' }}</app-button>
        </footer>
      </form>
    </section>
  </modal>
</template>

<script>
import { differenceInCalendarDays, format, parseISO } from 'date-fns'

export default {
  name: 'LeaveMutationModal',
  props: { name: { type: String, required: true }, submitRequest: { type: Function, required: true }, approve: Boolean },
  data() { return { leave: null, kind: 'cancel', form: {}, saving: false, error: '' } },
  computed: {
    leaveDays() {
      return this.leave.days || differenceInCalendarDays(parseISO(this.leave.to_date), parseISO(this.leave.from_date)) + 1
    }
  },
  methods: {
    formatDate(value) { return format(parseISO(value), 'dd MMM yyyy') },
    open(leave, kind) {
      this.leave = leave
      this.kind = kind
      this.form = { from_date: leave.from_date, to_date: leave.to_date, reason: '' }
      this.error = ''
      this.$modal.show(this.name)
    },
    close() { if (!this.saving) this.$modal.hide(this.name) },
    submit() {
      if (!this.form.reason || !this.form.reason.trim()) { this.error = 'Enter a reason.'; return }
      const payload = this.kind === 'change' ? { ...this.form } : { reason: this.form.reason }
      this.saving = true
      this.error = ''
      this.submitRequest(this.leave, this.kind, payload).then(() => {
        this.$modal.hide(this.name)
        this.$emit('saved')
      }).catch(error => {
        this.error = (error.response && error.response.data && error.response.data.details) || 'Unable to submit the request.'
      }).finally(() => { this.saving = false })
    }
  }
}
</script>

<style lang="scss" scoped>
.leave-mutation__form { padding: $ui-space-24; }

.leave-mutation__footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: $ui-space-16;
  margin-top: $ui-space-20;
}

.leave-mutation__notice { margin: 0 auto 0 0; }

.leave-mutation__period {
  display: flex;
  align-items: center;
  gap: $ui-space-12;
  margin-bottom: $ui-space-20;
  padding: $ui-space-16;
  border: 1px solid $ui-line;
  border-radius: $ui-control-radius;
  background: $ui-surface-soft;
}

.leave-mutation__date {
  display: grid;
  gap: $ui-space-4;
  min-width: 0;

  span {
    color: $ui-muted;
    font-size: $ui-font-size-metadata;
    font-weight: 600;
    letter-spacing: .03em;
    text-transform: uppercase;
  }

  strong { color: $ui-ink; white-space: nowrap; }
}

.leave-mutation__arrow { color: $ui-muted; font-size: 12px; }

.leave-mutation__days {
  margin-left: auto;
  padding: $ui-space-8 $ui-space-12;
  border-radius: $ui-control-radius;
  background: $ui-surface;
  color: $ui-ink;
  font-weight: 700;
  white-space: nowrap;
}

@media (max-width: 480px) {
  .leave-mutation__period { align-items: flex-start; flex-wrap: wrap; }
  .leave-mutation__days { margin-left: 0; }
}
</style>
